import { create } from 'zustand';

type AdminBreadcrumbStore = {
  lastLabel: string | null;
  setLastLabel: (label: string | null) => void;
};

export const useAdminBreadcrumbStore = create<AdminBreadcrumbStore>(set => ({
  lastLabel: null,
  setLastLabel: label => set({ lastLabel: label })
}));

export const useAdminBreadcrumbLastLabel = (): string | null =>
  useAdminBreadcrumbStore(state => state.lastLabel);

export const setAdminBreadcrumbLastLabel = (label: string | null): void =>
  useAdminBreadcrumbStore.getState().setLastLabel(label);
